import Pagination from './Pagination'

export type {PaginationProps} from './Pagination'
export default Pagination
